import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { environment } from '../../environments/environment';

/** Blocks routes for features that are still in development from being reached in production */
export const nonProductionGuard: CanActivateFn = () =>
  !environment.production || inject(Router).createUrlTree(['/home']);
